module.exports = __webpack_public_path__ + "2efb3b43c6a0329df35f1a0c2b2631a1.fbx";